import { report_passenger_flowService } from '../_services';

const state = { onRequest: false, report_passenger_flow: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        report_passenger_flowService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  report_passenger_flow: state => {
    return state.report_passenger_flow
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.report_passenger_flow = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.report_passenger_flow = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.report_passenger_flow = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const report_passenger_flows = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
